export default {"src":"/_next/static/media/helius.ccbbe629.svg","height":19,"width":89,"blurWidth":0,"blurHeight":0};